module.exports = __webpack_public_path__ + "img/记录.2da81638.png";